export default __webpack_public_path__ + "static/stepsinvlovd-c17d6350b1a308a270b4e8417a9d96aa.png";